<template>
  <TariffCard
    :title="__('website.tariffs.hr.header')"
    :subtitle="__('website.tariffs.hr.text1')"
    :footer-text="__('website.tariffs.hr.text2')"
    :discount="discount"
  >
    <CardPrice
      v-if="!showIndividualPrice"
      :currency="currency"
      :months="months"
      :prices="prices"
    />
    <IndividualPrice v-else />
    <CardInputsBlock>
      <CardInputsRow :title="__('website.tariffs.employees')">
        <CustomSelect
          v-model="selectedStaffGroup"
          :items="staffGroups"
        />
      </CardInputsRow>
    </CardInputsBlock>
  </TariffCard>
</template>

<script>
import { staffGroups, priceBystaffGroups } from '@/mainData';
import { calcHrPrices } from '@/utils';

import CustomSelect from '@/components/CustomSelect';

import TariffCard from './TariffCard';
import CardPrice from './CardPrice';
import CardInputsBlock from './CardInputsBlock';
import CardInputsRow from './CardInputsRow';
import IndividualPrice from './IndividualPrice';

export default {
  name: 'HrCard',

  components: {
    TariffCard,
    CardPrice,
    CustomSelect,
    CardInputsBlock,
    CardInputsRow,
    IndividualPrice,
  },

  props: {
    currency: {
      type: String,
      required: true,
    },
    months: {
      type: Number,
      required: true,
    },
    discount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      selectedStaffGroup: 0,
      staffGroups,
    };
  },

  computed: {
    prices() {
      return calcHrPrices({
        selectedGroup: this.selectedStaffGroup,
        months: this.months,
        discount: this.discount,
        currency: this.currency,
      });
    },
    showIndividualPrice() {
      return !priceBystaffGroups[this.selectedStaffGroup].price;
    },
  },
};
</script>